module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/cu-1452c504ef675071dcdf6ef2a44e55df.svg";